import { ReactNode, useMemo } from 'react';
import { EasyClaimCustomerConfigurationDto } from 'src/easyclaim.api.client.typescript/src';

import CustomerConfigurationContext from './CustomerConfigurationContextCore';

export const CustomerConfigurationProvider: React.FC<{
	configuration: EasyClaimCustomerConfigurationDto | undefined;
	children: ReactNode;
}> = ({ configuration, children }) => {
	return (
		<CustomerConfigurationContext.Provider
			value={useMemo(() => ({ configuration }), [configuration])}
		>
			{children}
		</CustomerConfigurationContext.Provider>
	);
};
